module.exports = __webpack_public_path__ + "img/cluj.929c47fb.jpg";